import * as React from 'react'
import * as st from './circlePlayButton.module.scss'
import { getPlaybackClickstreamRef } from '../../utils/getPlaybackClickstreamRef'
import { RecordRefTag } from '../recordReftag/recordReftag'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { PlayButton } from '../playButton/PlayButton'
import * as cn from 'classnames'
import { fillValues } from 'DVWebNodeUtils'
import { PlaybackContentLink } from '@shared/player'
import { IPlaybackStart } from '../../actions/player'

export interface ICirclePlayButtonProps {
  playbackData?: WpsRuntime.atv.wps.PlaybackActionDataProps
  sessionId: string
  pageTitleId: string
  isPackshot?: boolean
  usePlayer: boolean
  startPlayback: (content: PlaybackContentLink) => IPlaybackStart
}

export const CirclePlayButton = ({playbackData, sessionId, pageTitleId, isPackshot, usePlayer, startPlayback}: ICirclePlayButtonProps) => {

  if (!playbackData) {
    return null
  }

  const deeplinkingData = {
    fallbackUrl: playbackData.fallbackURL,
    titleId: playbackData.playbackID,
    resumeTime: playbackData.resumeTime,
    signInUrl: playbackData.signInURL,
    sessionId,
    pageTitleId,
    ref: getPlaybackClickstreamRef(playbackData.contentType, playbackData.entitlementType),
    videoType: playbackData.videoMaterialType
  }

  const classNames = cn(
    st.imagePlayButton,
    isPackshot ? st.packshotButton : undefined
  )

  const label = fillValues(playbackData.label, { lineBreak: ', ' })


  const triggerOnlinePlayback = (e: React.MouseEvent) => {
    const contentConfig = {
      asin: playbackData.playbackID,
      trailer: false,
      position: playbackData.resumeTime,
      ref: getPlaybackClickstreamRef(
        playbackData.contentType,
        playbackData.entitlementType
      ),
      videoType: playbackData.videoMaterialType,
      useFullView: true
    }

    startPlayback({
      contentConfig,
      signInUrl: playbackData.signInURL,
      playbackUrl: playbackData.playbackURL
    })
    e.preventDefault()
  }

  return (
    <RecordRefTag refTag='atv_dp_pb_circle'>
      <PlayButton
        deepLinkingData={deeplinkingData}
        className={classNames}
        href={playbackData.playbackURL}
        isSeeThrough
        isPackshotButton={isPackshot}
        ariaLabel={label}
        onClick={usePlayer ? triggerOnlinePlayback : undefined}
      />
    </RecordRefTag>
  )
}
